<template>
  <div id="nPrintingPageTable" class="print-list_box" v-infinite-scroll="loadMore">
    <div class="yto-box yto-box-pb">
      <!-- 搜索条件 -->
      <searchOptions
        ref="searchOption"
        :curComponent="'waybillDetailPage'"
        :productList="productList"
        :searchForm="form"
        :fromPage="curPackageInfo.curComponent"
        @resetForm="resetRuleForm"
        @searchFormData="searchFormData"
      ></searchOptions>
    </div>
    <!-- 操作按钮 -->
    <div class="yto-table yto-ks-box ksNewOrderTable" style="position: relative;padding:10px 25px;">
      <!-- 建包说明 -->
      <div class="y-mb-10 y-w-700 y-fs-12 y-mt-10 y-mb-15">
        <span>包名：{{curPackageInfo.buildPageName}}</span><span class="y-ml-20">包签号：{{curPackageInfo.packageWaybillNo}}</span>
      </div>
      <!-- 表格 -->
      <div class="ksOrderTable ksTableHeightStyle infinite-list-wrapper manyWaybillNoStyle" style="margin-bottom: 20px;overflow:auto">
        <table
          v-loading="loading"
          class="el-table el-table--fit el-table--scrollable-x el-table--enable-row-transition el-table--small el-table__header"
          cellspacing="0"
          cellpadding="0"
          border="0">
          <thead>
            <tr>
              <th width="32px" style="text-align:center;padding: 0px;" class="cell">
                <svg-icon icon-class="buxuan" class="icon-checked" @click.native="tableSelectAll" v-show="!isAllChecked && !isAllIndemitChecked"></svg-icon>
                <svg-icon icon-class="quanxuan" class="icon-checked" @click.native="tableSelectAll" v-show="isAllChecked"></svg-icon>
                <svg-icon icon-class="banxuan" class="icon-checked" @click.native="tableSelectAll" v-show="isAllIndemitChecked"></svg-icon>
              </th>
              <th width="180px">运单号</th>
              <th width="220px">订单号</th>
              <th width="120px">发件人</th>
              <th width="280px">收件人信息</th>
              <th width="100px">商品信息</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!tbody.length">
              <tr class="el-table__body-wrapper is-scrolling-none ">
                <td :colspan="6" class="el-table__expanded-cell" style="text-align:center;">
                  <span class="el-table__empty-text">暂无数据</span>
                </td>
              </tr>
            </template>
            <template v-for="(item, index) in tbodyBak">
              <tr
                class="el-table__row"
                :class="{'table-active-row':tableRowClassName(item)}"
                :key="index"
                @click="checkedRow(item)">
                <td style="text-align:center;">
                  <svg-icon icon-class="buxuan" class="icon-checked" v-show="!item.isChecked && !item.isPartChecked"></svg-icon>
                  <svg-icon icon-class="quanxuan" class="icon-checked" v-show="!item.isPartChecked && item.isChecked"></svg-icon>
                  <svg-icon icon-class="banxuan" class="icon-checked" v-show="item.isPartChecked"></svg-icon>
                </td>
                <td class="opacity-coloumn">
                  <div><span>{{item.mailNo || ''}}</span></div>
                </td>
                <td class="opacity-coloumn">
                  <div>{{item.orderNo || ''}}</div>
                </td>
                <td class="opacity-coloumn">
                  <div>{{item.senderName}}</div>
                </td>
                <td class="opacity-coloumn">
                  <div slot="reference" class="cell" style="padding-right: 10px;">
                    <el-popover
                      placement="top-start"
                      trigger="hover">
                      <div>{{item.receiverName || ''}} {{item.receiverMobile || ''}}</div>
                      <div>{{item.receiveProv || ''}}{{item.receiveCity || ''}}{{item.receiveDict || ''}}{{item.receiveAddress || ''}}</div>
                      <div class="elli2" slot="reference">
                        <div>{{item.receiverName || ''}} {{item.receiverMobile || ''}}</div>
                        <div>{{item.receiveProv || ''}}{{item.receiveCity || ''}}{{item.receiveDict || ''}}{{item.receiveAddress || ''}}</div>
                      </div>
                    </el-popover>
                  </div>
                </td>
                <td class="opacity-coloumn">
                  <div slot="reference" class="cell" style="padding-right: 10px;">
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      width="230">
                      <div v-for="(pro, pri) in item.goodInfoResponseList" :key="pri">{{`${pro.productName || ''} * ${pro.productNum || 1} / 重量：`}}<span :class="{'y-fc-F0484A': !pro.productWeight}">{{pro.productWeight ? parseInt(pro.productWeight * 100)/100 : 0}}</span>Kg</div>
                      <div class="elli2" slot="reference">
                        <div v-for="(pro, pri) in item.goodInfoResponseList" :key="pri">{{`${pro.productName || ''} * ${pro.productNum || 1} / 重量：`}}<span :class="{'y-fc-F0484A': !pro.productWeight}">{{pro.productWeight ? parseInt(pro.productWeight * 100)/100 : 0}}</span>Kg</div>
                      </div>
                    </el-popover>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- 分页 -->
      <div class="paginton-footer-box box-shadow-wrapper">
        <!-- 选择模板 -->
        <changeTemplate
          v-if="isRefreshTemplate"
          :platformCode="'BQDYXQ'"
          :curComponent="'PACKUP_PACKAGE'"
          :templateAList="templateAList"
          :curTemplateId="repeatPrintedForm.tempId"
          @changeTemplateId="changeTemplateId"
          @addOneTemplate="isShowAddTemplateDialog=true"
          @deleteTemplate="deleteTemplate"
        ></changeTemplate>
        <div class="split-line"></div>
        <!-- 分页器 -->
        <div class="totalFooter-top y-f-a">
          <div class="print-footer-left y-f y-f-a">
            <span>已选<span class="totalNumStyle systemColor">{{selectData.length}}</span>条记录</span>
          </div>
          <div class="print-footer-medium y-f y-f-a">
            <el-button class="border-btn" @click="batchPrinting">打印运单</el-button>
          </div>
          <el-pagination
            @size-change="limitChange"
            @current-change="pageChange"
            :current-page.sync="pageNo"
            :page-sizes="[50, 100, 200, 300, 400]"
            :page-size="limit"
            :pager-count="5"
            layout="total, sizes, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 打印快递单弹层 -->
    <el-dialog
      title="打印运单"
      :visible.sync="repeatPrintedDialogVisible"
      width="725px"
      custom-class="ninvoiceDialog"
      :close-on-click-modal="false"
      :before-close="closeRepeatForm">
      <el-form :model="repeatPrintedForm" label-width="190px" ref="repeatPrintedForm" :rules="repeatPrintedFormRules">
        <printWarningTip
          :dygfWaybillList="dygfWaybillList || {}"
          :selectPrinterForm="repeatPrintedForm"
        ></printWarningTip>
        <el-form-item label="您本次选择的打印模板是：">
          <el-tooltip class="item" effect="light" :content="`${curTemplateInfo.addressInfo || ''}`" placement="top-start">
            <div>
              <span>{{curTemplateInfo.tempName}}</span>
              <span v-if="!cpCodeList.includes(curTemplateInfo.wpCode)" :class="{'systemGreenColor': repeatPrintedForm.available >= 100, 'systemRedColor': repeatPrintedForm.available < 100}">({{repeatPrintedForm.available || 0}})</span>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="快递单打印机" prop="printer">
          <span class="custom-select-style">
            <span class="systemColor" v-text="getDefautPrinter()"></span>
            <el-select
              :popper-append-to-body="false"
              v-model="repeatPrintedForm.printer"
              placeholder="请选择快递单打印机"
              class="custom-select-border-style"
              :class="{'custom-select-style-input-default-printer': getDefautPrinter() == '默认', 'custom-select-style-input-pinter': getDefautPrinter() !== '默认'}">
              <el-option v-for="(item, index) in dyPrinterList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </span>
          <span v-if="dyPrinterList.length" class="systemColor" style="font-size:12px;margin-left:5px;cursor:pointer;" @click="setDefaultPrinter">设置默认打印机</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer align-center-box">
        <el-button @click="closeRepeatForm">取 消</el-button>
        <el-button type="primary" @click="repeatSubmitPrint">打印运单</el-button>
      </div>
    </el-dialog>
    <!-- 打印弹层校验发件人、打印组件、模板信息 -->
    <validatePrintItems
      v-if="isShowValidateDialog"
      :isShow="isShowValidateDialog"
      :senderList="[]"
      :curSenderId="repeatPrintedForm.sernderId"
      :templateAList="templateAList"
      :curTemplateId="repeatPrintedForm.tempId"
      :step="validateStep"
      :platformType="'BQDY'"
      @closeValiDialog="closeValiDialog"
      @refreshOriginList="refreshOriginList"
      @addOneTemplate="addOneTemplate"
    ></validatePrintItems>
    <!-- 添加模板 -->
    <addTemplateDialog
      v-if="isShowAddTemplateDialog"
      :visible.sync="isShowAddTemplateDialog"
      :tplList="templateAList"
      :defaultCpCode="defaultCpCode"
      :defaultPlatformType="defaultPlatformType"
      :closeByConfirm="getTemplateList"
    ></addTemplateDialog>
    <!-- 打印快递单进度 -->
    <orderPrint
      ref="orderPrintComponent"
      @close-print-dialog="closePrinterDialog"
    ></orderPrint>
    <!-- 查看订单详情 -->
    <order-detail
      :info="JSON.stringify(detailInfo)"
      :value="orderDetialDialogVisible"
      @close="closeDetialDialog"
    ></order-detail>
  </div>
</template>

<script>
import util from '@/utils/util';
import { dateFormat } from '@/utils/util';
import dyPrint from '@/utils/douyinPrint';
import printWarningTip from '@/components/printWarningTip/printWarningTip'; // 打印组件未识别提示语
import searchOptions from './components/searchOptions'; // 搜索条件中的省市区筛选
import changeTemplate from '@/components/printValidate/changeTemplate'; // 切换打印模板
import validatePrintItems from '@/components/printValidate/validatePrintItems'; // 校验打印弹层中发件人、快递单模板、打印组件等
import addTemplateDialog from '@/views/baseInfo/printTemplate/eleFaceSheetTpl/components/addFaceTpl.vue'; // 添加模板弹层
import orderPrint from './components/orderPrint'; // 标准快递单打印快递单进度
import orderDetail from './components/orderDetail'; // 订单详情
import { getCustomerUserPrintTempListApi, lubanNetsiteApi, updatePrintTplApi } from '@/api/universal';
import { waybillByPackageNo, getPackageProductListApi } from '@/api/waybillPrint/buildPackge';
export default {
  name: 'printingTable',
  components: {
    printWarningTip,
    searchOptions, // 搜索条件
    changeTemplate,
    validatePrintItems, // 校验打印弹层中发件人、快递单模板、打印组件等
    addTemplateDialog, // 添加模板
    orderPrint,
    orderDetail
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  props: {
    curComponent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isAllChecked: true,
      isAllIndemitChecked: false,
      loading: false,
      form: {
        queryDateType: '0',
        createTime: '',
        pickStatus: '',
        printStatus: '',
        buildPackageType: '',
        packageName: '',
        packageNo: '',
        carNo: '',
        mailNo: '',
        shortAddress: '',
        productCode: ''
      },
      total: 0,
      pageNo: 1,
      limit: 50,
      tbody: [],
      tbodyBak: [],
      selectData: [],
      screenH: null,
      screenW: null,
      isShowValidateDialog: false,
      validateStep: null,
      templateAList: [],
      isShowAddTemplateDialog: false,
      isRefreshTemplate: true,
      repeatPrintedForm: {
        sernderId: '',
        tempId: '',
        printer: ''
      },
      repeatPrintedFormRules: {
        printer: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      repeatPrintedDialogVisible: false,
      defaultCpCode: '',
      defaultPlatformType: '',
      cpCodeList: ['SF', 'EMS', 'YZKDBG'], // 这几个快递公司不显示余额
      curTemplateInfo: {},
      dyPrinterList: [],
      dyAlertTitle: '',
      dygfWaybillList: util.dygfWaybillList || [], // 抖音官方模板
      orderDetialDialogVisible: false,
      detailInfo: {},
      curPackageInfo: {},
      productList: []
    };
  },
  created() {
    // 获取当前分辩率宽度
    this.screenW = window.screen.width || document.body.clientWidth;
    // 获取当前分辨率高度
    this.screenH = window.screen.height || document.body.clientHeight;
    if (!dyPrint.dyWebsocket) {
      dyPrint.getPrinterList();
    }
    let paramsObj = localStorage.getItem('printRecordDetail');
    this.curPackageInfo = paramsObj && JSON.parse(paramsObj);
    // 查询商品列表
    // this.getProductList();
  },
  mounted() {
    this.init();
  },
  methods: {
    // 打印组件初始化
    initPrintCompont() {
      if(!dyPrint.dyWebsocket || (dyPrint.dyWebsocket.readyState != 1)){
        dyPrint.getPrinterList();
        this.getDyPrinterList();
      }else if(dyPrint.dyWebsocket){
        this.getDyPrinterList();
      }
    },
    // 获取抖音打印机列表
    getDyPrinterList(){
      setTimeout(() => {
        this.dyPrinterList = dyPrint.printerObj.printerList || [];
        this.dyAlertTitle = dyPrint.dyWebsocket && dyPrint.printerObj.printerList.length ? '' : dyPrint.printerObj.alertTitle;
      }, 500);
    },
    loadMore() {
      // 分页小于200页时，不滚动加载，一次加载全即可
      if (this.limit <= 200) {
        return false;
      }
      // 分页大于等于200页，需滚动按需加载
      let len = this.tbody.length;
      if (this.startIndex > len || this.tbodyBak.length === len) {
        return false;
      }
      let tempEndIndex = this.startIndex + parseInt(this.splitNum);
      if (tempEndIndex < len ) {
        let arr = this.tbody.slice(this.startIndex, tempEndIndex);
        this.tbodyBak = this.tbodyBak.concat(arr);
        this.startIndex = tempEndIndex;
      } else {
        let arr2 = this.tbody.slice(this.startIndex, len);
        this.tbodyBak = this.tbodyBak.concat(arr2);
        this.startIndex = len;
      }
    },
    // 页面初始化
    init() {
      // 查询打印列表
      this.getOrders();
      this.initPrintCompont();
      // 获取打印模板列表
      this.getTemplateList();
    },
    // 每页条数改变
    limitChange(limit) {
      this.startIndex = 0;
      this.limit = limit;
      this.pageNo = 1;
      this.getOrders();
    },
    // 页码改变
    pageChange(page) {
      this.startIndex = 0;
      this.pageNo = page;
      this.getOrders();
    },
    // 重置搜索框
    resetRuleForm(params) {
      this.form = params;
      this.$nextTick(()=>{
        this.pageChange(1);
      })
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
    // 查询表格
    searchFormData(params) {
      this.form = {...params};
      this.pageChange(1);
    },
    // 获取查询列表的参数
    getParams() {
      let copyForm = JSON.parse(JSON.stringify(this.form));
      let params = {
        mallCode: this.curPackageInfo.mallCode,
        packageNo: this.curPackageInfo.packageWaybillNo,
        packageId: this.curPackageInfo.id,
        mailNo: copyForm.mailNo,
        productCode: copyForm.productCode,
        mallPlatform: "LUBAN"
      };
      return params;
    },
    // 获取订单数据，注入表格
    async getOrders() {
      let query = this.getParams();
      if(!query) return; // 参数获取失败
      // 列表查询
      this.getWaybillByPackageNo(query);
    },
    // 列表查询
    async getWaybillByPackageNo(query) {
      this.isAllChecked = false;
      this.isAllIndemitChecked = false;
      this.selectData = []; // 复选框勾选的数据置空
      this.loading = true;
      waybillByPackageNo(query).then(res => {
        if (res.success) {
          if (res.data && res.data.hasOwnProperty('total')) {
            this.tbody = res.data.items || [];
            this.startIndex = 0;
            this.tbody.forEach(item => {
              item.goodInfoResponseList = item.goodInfoResponseList || [];
              this.$set(item, 'isChecked', false);
              this.$set(item, 'isPartChecked', false);
            });
            if (this.limit > 200) {
              this.tbodyBak = this.tbody.slice(this.startIndex, this.splitNum);
              this.startIndex = (this.startIndex + this.splitNum);
            } else {
              this.tbodyBak = this.tbody;
            }
          } else {
            this.tbody = [];
            this.tbodyBak = [];
          }
          this.total = res.data.total || 0;
        } else {
          this.tbody = [];
          this.tbodyBak = [];
          this.total = 0;
          this.$message.error(res.error || res.message || '获取数据失败，请稍候重试');
        }
        this.loading = false;
      }).catch((err) => {
        this.tbody = [];
        this.tbodyBak = [];
        this.total = 0;
        this.loading = false;
        this.$message.error(err.error || err.message || '网络异常，请稍候重试');
      });
    },
    // 复选框全选
    tableSelectAll(selection) {
      this.isAllChecked = !this.isAllChecked;
      this.isAllIndemitChecked = false;
      if(!this.tbody || !this.tbody.length) return;
      if (this.isAllChecked) {
        this.selectData = [];
        this.tbody.forEach(item => {
          this.$set(item, 'isChecked', true);
          this.selectData.push(item);
        });
      } else {
        this.tbody.forEach(item => {
          this.$set(item, 'isChecked', false);
        });
        this.selectData = [];
      }
    },
    // 选中行
    checkedRow(row) {
      this.$set(row, 'isChecked', !row.isChecked);
      if (row.isChecked) {
        this.selectData.push(row);
      } else {
        let index = this.selectData.findIndex(rowItem => { return rowItem.id === row.id; });
        if (index > -1) {
          this.selectData.splice(index, 1);
        }
      }
      if (this.selectData.length == this.tbody.length) {
        this.isAllChecked = true;
        this.isAllIndemitChecked = false;
      } else if (this.selectData.length) {
        this.isAllIndemitChecked = true;
        this.isAllChecked = false;
      } else {
        this.isAllChecked = false;
        this.isAllIndemitChecked = false;
      }
    },
    // 对应行显示不同颜色
    tableRowClassName(row) {
      if (row && row.isChecked) {
        return true;
      } else {
        return false;
      }
    },
    // 获取打印模板
    async getTemplateList(refreshFlag) {
      // 关闭添加模板弹层
      this.isShowAddTemplateDialog = false;
      this.isShowValidateDialog = false;
      this.defaultCpCode = "";
      this.defaultPlatformType = "";
      await getCustomerUserPrintTempListApi({loginId: this.userMess.loginId, waybillCode: 'LUBAN_LUBAN'}).then(res => {
        if (res.message === 'ok') {
          let tempList = res.data || [];
          // 屏蔽抖音老模板
          this.templateAList = tempList.filter(item => { return util.dygfWaybillList.includes(item.baseTempId) && item.platformTypeOfWayBill !== 'DYDF'; });
          // console.log('this.templateAList------------', this.templateAList);
          if (refreshFlag === 'refresh') {
            // 重新设置当前所选模板信息
            this.valiBeforePrint();
          } else if (refreshFlag !== 'delete') {
            this.setDefaultTemplateList();
          }
          // 添加、删除完模板需要更新模板组件
          this.isRefreshTemplate = false;
          this.$nextTick(() => {
            this.isRefreshTemplate = true;
          });
        } else {
          this.templateAList = [];
        }
      }).catch(() => {
        this.templateAList = [];
      });
    },
    // 获取快递单打印模板列表
    setDefaultTemplateList() {
      this.repeatPrintedForm.tempId = '';
      let localTemplateId = localStorage.getItem('LUBAN_templateId');
      let defaultTemplate = this.templateAList.filter(item => { return item.isDefault === 'Y'; });
      let cureTempObj = null;
      if (defaultTemplate.length) {
        // 优先选中默认模板
        this.repeatPrintedForm.tempId = defaultTemplate[0].id;
        cureTempObj = defaultTemplate[0];
      } else if (localTemplateId) {
        // 若有本地选中模板，则将本地选中模板置为模板的第一项并选中
        let index = this.templateAList.findIndex(item => { return item.id === localTemplateId; });
        if (index > -1) {
          let newList = this.templateAList.splice(index, 1);
          this.templateAList.unshift(newList[0]);
          this.repeatPrintedForm.tempId = this.templateAList[0].id;
          cureTempObj = this.templateAList[0];
        }
      }
      // 获取模板中设置的默认打印机
      if (cureTempObj && cureTempObj.defaultPrint) {
        let printer = this.dyPrinterList.filter(dyItem => { return dyItem.name === cureTempObj.defaultPrint; });
        this.repeatPrintedForm.printer = printer.length ? printer[0].name : '';
      }
    },
    // 获取快递单打印模板列表
    // getTemplateList() {
    //   this.repeatPrintedForm.tempId = '';
    //   let localTemplateId = localStorage.getItem('LUBAN_templateId');
    //   let defaultTemplate = this.templateAList.filter(item => { return item.isDefault === 'Y'; });
    //   if (defaultTemplate.length) {
    //     // 优先选中默认模板
    //     this.repeatPrintedForm.tempId = defaultTemplate[0].id;
    //   } else if (localTemplateId) {
    //     // 若有本地选中模板，则将本地选中模板置为模板的第一项并选中
    //     let index = this.templateAList.findIndex(item => { return item.id === localTemplateId; });
    //     if (index > -1) {
    //       let newList = this.templateAList.splice(index, 1);
    //       this.templateAList.unshift(newList[0]);
    //       this.repeatPrintedForm.tempId = this.templateAList[0].id;
    //     }
    //   }
    // },
    // 切换选中模板
    changeTemplateId(id) {
      this.repeatPrintedForm.tempId = id;
    },
    // 删除模板
    deleteTemplate() {
      this.repeatPrintedForm.tempId = '';
      this.refreshOriginList('delete');
    },
    // 鲁班查询余额
    listShopNetsite(row) {
      let params = {
        logisticsCode: util.logisticsObj[row.wpCode],
        mallId: row.mallId
      };
      this.$set(this.repeatPrintedForm, 'available', 0);
      lubanNetsiteApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data.netsites || [];
          let oList = list.filter(item => { return item.netsite_code === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].amount || 0) : 0;
          this.$set(this.repeatPrintedForm, 'available', available);
        }
      }).catch(() => {});
    },
    // 关闭打印前校验弹层
    closeValiDialog(str) {
      this.isShowValidateDialog = false;
      if (str === 'ok') {
        // 检测抖音组件
        this.initPrintCompont();
        this.$nextTick(() => {
          this.repeatPrintedDialogVisible = true;
        });
      } else {
        this.closeRepeatForm();
      }
    },
    // 重新设置单号源后查询模板列表
    refreshOriginList(str) {
      // 重新设置当前所选模板信息
      this.getTemplateList('refresh');
    },
    // 如果没有模板，点击立即设置，打开添加模板弹层，并定位到当前平台的圆通模板
    addOneTemplate(params) {
      if (params) {
        this.defaultCpCode = 'YTO';
        this.defaultPlatformType = params.openPlatformType || 'YTO';
      }
      this.isShowAddTemplateDialog=true;
    },
    // 获取默认打印机列表
    getDefautPrinter() {
      let str1 = '';
      if (this.repeatPrintedForm.printer === this.curTemplateInfo.defaultPrint) {
        str1 = '默认';
      }
      return str1;
    },
    // 设置默认打印机
    setDefaultPrinter() {
      if (!this.repeatPrintedForm.printer) {
        this.$refs.repeatPrintedForm.validateField(['printer']);
        return false;
      }
      let obj = this.curTemplateInfo;
      obj.defaultPrint = this.repeatPrintedForm.printer;
      obj.userId = this.userMess.loginId;
      updatePrintTplApi(obj).then(res => {
        if (res.message === 'ok') {
          this.getDefautPrinter();
          this.getTemplateList();
        }
      });
    },
    // 打印前校验
    valiBeforePrint() {
      // 获取模板信息
      this.curTemplateInfo = {};
      this.repeatPrintedForm.printer = '';
      this.netSendInfo = {};
      this.templateAList.forEach(item => {
        if (item.id == this.repeatPrintedForm.tempId) {
          this.$set(this.repeatPrintedForm, 'platformCode', item.waybillCode);
          this.$set(this.repeatPrintedForm, 'baseTempId', item.baseTempId);
          this.$set(this.repeatPrintedForm, 'cpCode', item.wpCode); // 模板对应的物流公司类型
          // 获取模板中设置的默认打印机
          if (item.defaultPrint) {
            console.log('this.dyPrinterList', this.dyPrinterList);
            let printer = this.dyPrinterList.filter(dyItem => { return dyItem.name === item.defaultPrint; });
            this.repeatPrintedForm.printer = printer.length ? printer[0].name : '';
            console.log('printer', printer);
          }
          // 模板面单来源拼接，用于模板title提示
          item.addressInfo = '';
          if (item.addressInfoList && item.addressInfoList.length) {
            let obj = item.addressInfoList[0];
            let str = (obj.province || '') + (obj.city || '') + (obj.district || '') + (obj.detail || '');
            item.addressInfo = str ? (item.tempName + ' - ' + str) : item.tempName;
            // 收集面单来源信息
            this.netSendInfo = {
              branchName: item.branchNameOfWayBill,
              mallId: item.printAccount || '',
              branchCode: item.branchCodeOfWayBill,
              ...obj
            };
          }
          this.curTemplateInfo = item;
          this.listShopNetsite(item);
        }
      });
      // 校验模板信息---模板中没有设置默认单号源--无需校验单号源
      // if (!(this.curTemplateInfo.addressInfoList && this.curTemplateInfo.addressInfoList.length)) {
      //   this.validateStep = '2';
      //   this.isShowValidateDialog = true;
      //   return false;
      // }
      // 校验打印组件是否开启
      let titleTip = dyPrint.printerObj.alertTitle;
      if (this.dyAlertTitle || titleTip) {
        this.validateStep = '3';
        this.isShowValidateDialog = true;
        return false;
      }
      return true;
    },
    // 打印包签 / 建包
    batchPrinting() {
      // 检测菜鸟组件、拼多多组件优化
      this.initPrintCompont();
      if (!this.selectData.length) {
        this.$confirm('请先勾选您要打印的运单方可打印', '', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {}).catch(() => {
          return false;
        });
        return false;
      }
      // 如没有打印模板，点击打印时弹出校验层
      if (!this.templateAList.length) {
        this.validateStep = '2';
        this.isShowValidateDialog = true;
        return false;
      }
      // 打印前参数校验
      if (!this.repeatPrintedForm.tempId) {
        this.$message.error('请在下方模板栏选择一个打印模板');
        return false;
      }
      // 打印前校验
      let valieBeforeFlag = this.valiBeforePrint();
      if (!valieBeforeFlag) {
        return false;
      }
      this.$nextTick(() => {
        this.repeatPrintedDialogVisible = true;
      });
    },
    // 打印包签、建包
    repeatSubmitPrint() {
      this.$refs['repeatPrintedForm'].validate((valid) => {
        if (valid) {
          if(
            this.repeatPrintedForm.platformCode === 'LUBAN' &&
            this.dygfWaybillList.includes(this.repeatPrintedForm.baseTempId) &&
            this.dyAlertTitle
          ) {
            this.$message.error('若您还未安装抖音打印组件，请先安装并启动后刷新页面！');
            return;
          }
          console.log('netSendInfo', this.netSendInfo);
          this.repeatPrintedForm.curMallCode = this.curPackageInfo.mallCode;
          this.repeatPrintedForm.curMallName = this.curPackageInfo.mallName || '';
          this.repeatPrintedForm.packageWaybillNo = this.curPackageInfo.packageWaybillNo || '';
          localStorage.setItem(`LUBAN_templateId`, this.repeatPrintedForm.tempId);
          // 全局定义批次
          let date = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss');
          let dateStr = date.replace(/[- :]/g, '').substring(2, 14);
          let printBatch = `${dateStr}99${util.getUUID(4, 10)}`;
          // 打印进度层显示
          this.orderPrintVisible = true;
          this.$refs.orderPrintComponent.printBatch = printBatch; // 批次
          this.$refs.orderPrintComponent.isPrintPackageSign = 'WAYBILL'; // 打印类型标记，  BAO 只打印包签， WAYBILL 只打印运单， BULK 打印散单 ALL 整包打印
          this.$refs.orderPrintComponent.data = JSON.parse(JSON.stringify(this.selectData));
          this.$refs.orderPrintComponent.tempInfo = JSON.parse(JSON.stringify(this.curTemplateInfo));
          this.$refs.orderPrintComponent.formInfo = JSON.parse(JSON.stringify(this.repeatPrintedForm));
          this.$refs.orderPrintComponent.netSendInfo = JSON.parse(JSON.stringify(this.netSendInfo));
          this.$refs.orderPrintComponent.init(); // 调用打印子组件
          this.closeRepeatForm();
        }
      });
    },
    // 关闭原单重打弹层
    closeRepeatForm() {
      this.repeatPrintedDialogVisible = false;
      this.orderPrintVisible = false;
      // 关闭弹层后取消勾选的订单
      this.isAllChecked = true;
      this.isAllIndemitChecked = false;
      this.tableSelectAll();
      this.isShowValidateDialog = false;
    },
    // 关闭打印进度弹层
    closePrinterDialog() {
      this.closeRepeatForm();
      this.getOrders();
    },
    // 取消散件标记
    recoverBlukFn(row) {
      console.log('散件....', row);
      this.$confirm(`确认要将${row.mailNo}取消散件标记吗？`, '', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        closeOnClickModal: false
      }).then(() => {
        // 确认取消标记，调用接口...
      }).catch(() => {
        return false;
      });
    },
    // 查看订单详情
    detail(row) {
      this.detailInfo = row;
      this.orderDetialDialogVisible = true;
    },
    // 关闭详情窗口
    closeDetialDialog() {
      this.orderDetialDialogVisible = false;
    },
    // 查询商品信息
    getProductList() {
      // 没有店铺则不查询商品信息
      if (!this.curPackageInfo.mallCode) {
        return false;
      }
      let parasmQuery = {
        mallPlatform:"LUBAN",
        mallCode: this.curPackageInfo.mallCode
      };
      getPackageProductListApi(parasmQuery).then(res => {
        this.productList = res.data || [];
      }).catch(() => {
        this.productList = [];
      });
    }
  },
  beforeDestroy() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../../../styles/variables";
  .flex {
    display: flex;
		justify-content: flex-start;
		align-items: center;
  }
  .flex-between {
    justify-content: space-between;
  }
  .ml10{
    margin-left: 10px;
  }
  .ml30{
    margin-left: 30px;
  }
  .w150{
    display: inline-block;
    width: 150px;
  }
  .mr20 {
    margin-right: 20px;
  }
  #nPrintingPageTable {
    background-color:#e4e7ed;
    .linkColor{
      color:$blue-style;
      cursor: pointer;
    }
    .el-table tr td {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #EBEEF5;
      .elli2 {
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient:vertical;
      }
    }
    .el-table .cell {
      padding-left: 0px;
      padding-right: 0px;
      .elli {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
  .el-dialog.ninvoiceDialog .el-select .el-input--suffix{
    width: 320px;
  }
  .red-border-btn {
    border-color: #F0484A;
    color: #F0484A;
  }
</style>
<style lang='scss'>
.ksOrderTable .el-table__body-wrapper {
  padding-bottom: 62px;
}
.ksOrderTable.ksTableHeightStyle {
  min-height: 500px;
}
</style>
